document.addEventListener("dfield:discountsUpdated", () => {
  fetch('/cart.js')
    .then(r => r.json())
    .then(refreshCart)
    .catch(err => console.error('Failed to refresh cart', err));
});


function refreshCart(cart) {
  $(".cart_count").empty();
  $cartBtn = $(".cart_count");
  var value = $cartBtn.text() || '0';
  var cart_items_html = "";
  var cart_discounts_html = "";
  var cart_action_html = "";
  var cart_savings_html = "";
  var $cart_form = $('[data-cart-form]');
  var productHasSale = false;
  var productCompareAtPrice = 0;
  var productFinalPrice = 0;

  $cart_form.data('total-discount', cart.total_discount);

  $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));

  if (cart.item_count == 0) {
    $('.js-empty-cart__message').removeClass('hidden');
    $cart_form.addClass('hidden');
  } else {
    $('.js-empty-cart__message').addClass('hidden');
    $cart_form.removeClass('hidden');

    var total_saving = 0; // adding counter variables for total cart savings
    var saving = 0;

    $.each(cart.items, function(index, item) {
      var itemDiscounts = item.discounts;
      var discountMessage = "";

      for (i=0; i < itemDiscounts.length; i++) {
        var amount = Shopify.formatMoney(itemDiscounts[i].amount, $('body').data('money-format'));
        var title = itemDiscounts[i].title;
        discountMessage = '<p class="notification-discount meta">' + title + '</p>';
      }
      var line_id = index + 1;

      cart_items_html += '<li class="mini-cart__item clearfix" data-cart-item data-line-id="' + line_id + '" data-variant-id="' + item.id + '">' +
        '<a href="' + item.url +'">';
      if (item.image) {
        cart_items_html += '<div class="cart_image">' +
            '<img class="lazyload" data-src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
          '</div></a>';
      }

      cart_items_html += '<div class="mini-cart__item--content"><div class="mini-cart__item__title"><div class="item_title"><a href="' + item.url + '">' + item.title + '</a></div>';

      if(item.properties) {

        $.each(item.properties, function(title, value) {
  
          
          if (value) {
            
            
            if ( item.title != "Servicio de Instalación Grifería" ){
                          
                if (  title == "Instalar Para" ||  title == "dateRequest"  )
                {
                
                }
                          
                else
                {

          cart_items_html += '<div style="display:none;" class="line-item">' +"<strong class='install'>"+ title +"</strong>" +': ' + value + ' </div>';
                }

              }
                                                      
            if ( item.title == "Servicio de Instalación Grifería" ){
                  if (  title == "dateRequest" ||  title == "Comuna" ||  title == "Instalación"  )
                  {
                  //lol
                  
                  }
            
            else
              
            {

              cart_items_html += '<div style="display:none;" class="line-item">' +"<strong class='install'>"+ title +"</strong>"+': ' + value + ' </div>';
              
            }
          }
        

          }
          
          
          
        });
          
        
      }

      cart_items_html += '<strong class="right price">';

      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        url: "/products/" + item.handle + ".js",
        success: function(data) {
          // If item has more than one variant, need to make sure we are pulling data from the correct variant
          if (data.variants) {
            var itemVariants = data.variants;
            if (itemVariants.length > 1) {
              for (v = 0; v < itemVariants.length; v++) {
                if (itemVariants[v].id == item.id) {
                  var data = itemVariants[v];
                }
              }
            }
          }

          // If compare at price exists then item is on sale
          if (data.compare_at_price) {
            if(data.compare_at_price > data.price) {
              productHasSale = true;
              productCompareAtPrice = data.compare_at_price;
              productFinalPrice = data.price;
            }
          } else {
            // Check required for non-sale items
            productHasSale = false;
          }
        }
      });

      if(productHasSale == true) {
        
        
        if ( item.title == "Servicio de Instalación Grifería" ){

        var itemPrice = Shopify.formatMoney(item.price, $('body').data('money-format'));
          cart_items_html += '<span class="money">' + itemPrice + '</span></strong>';

        }
                
        else
        {
        //puts the slash through the old item price
        var itemPrice = Shopify.formatMoney(productFinalPrice, $('body').data('money-format')) + ' </span><span class="money was_price">' + Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format')) + '</span>';
        cart_items_html += '<span class="money sale with_discount">' + itemPrice + '</strong>';
        saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
        total_saving = saving + total_saving;

        } 
          

        // Total savings
        
      } else {
        if (item.price > item.final_price) {
          //puts the slash through the old item price
          var itemPrice = Shopify.formatMoney(item.final_price, $('body').data('money-format')) + ' </span><span class="money was_price">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span>';
          cart_items_html += '<span class="money sale">' + itemPrice + '</strong>';
        } else {
          var itemPrice = Shopify.formatMoney(item.price, $('body').data('money-format'));
          cart_items_html += '<span class="money">' + itemPrice + '</span></strong>';
        }
      }

      if (item.price > item.final_price) {
        cart_items_html += discountMessage;
      }
      
      
      /*cart_items_html += '<div class="left product-quantity-box">';
      cart_items_html += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
      cart_items_html += '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" data-cart-quantity-input="mini-cart" />';
      cart_items_html += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
      cart_items_html += '</div></div></div>';*/
      
      cart_items_html +="Cantidad: "+item.quantity;
      cart_items_html += '<a href="/cart/change?line=' + line_id +
      '&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="' + line_id + 
      '" data-remove-item="mini-cart"><span class="remove-icon"></span></a>';

    });

    var cartDiscounts = cart.cart_level_discount_applications;
    var cartDiscountMessage = "";

    for (i=0; i < cartDiscounts.length; i++) {
      var amount = Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
      var title = cartDiscounts[i].title;

      cart_discounts_html += '<span class="cart_discounts--title">' + title + '</span>';
      cart_discounts_html += '<span class="cart_discounts--price">';
      cart_discounts_html += '-<span class="money">' + amount + '</span></span>';
    }

    cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' + '<span>' + Shopify.translation.cart_subtotal_text + '</span>';
    total_saving = total_saving + cart.total_discount;
    if(Shopify.theme_settings.display_savings && total_saving > 0) {
      cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_saving, $('body').data('money-format')) + '</span></span>' +
          '<span>' + Shopify.translation.cart_savings_text + '</span>';
    } else {
      cart_savings_html = "";
    }
  }

  $('.js-cart_items').html(cart_items_html);
  $('.js-cart_discounts').html(cart_discounts_html);
  $('.js-cart_subtotal').html(cart_action_html);
  $('.js-cart_savings').html(cart_savings_html);

  // Converting the currencies
  if (Currency.show_multiple_currencies) {
    currencyConverter.convertCurrencies();
  }

}